function initFAQs() {
	if (!$('.m__faqs').length) {
		return;
	}

	$('.m__faqs').each(function () {
		var $module = $(this);
		var $filter = $module.find('.js__faqs-filter');
		var $questions = $module.find('.js__faqs-questions');

		$module.find('.m__faqs-item:visible:last').addClass('is-last');

		$module.on('click', '.js__faqs-toggle', function () {
			var $toggle = $(this);
			$toggle.toggleClass('is-open');
			$toggle.siblings('.js__faqs-answer').stop(true, true).slideToggle();
		});

		if ($filter.length && $.fn.slick) {
			$filter.slick({
				slidesToShow: 1,
				mobileFirst: true,
				dots: false,
				arrows: false,
				adaptiveHeight: true,
				responsive: [
					{
						breakpoint: 992,
						settings: 'unslick'
					}
				]
			});
		}

		$module.on('click', '.js__faqs-slider-prev', function () {
			if ($filter.hasClass('slick-initialized')) {
				$filter.slick('slickPrev');
			}
		});

		$module.on('click', '.js__faqs-slider-next', function () {
			if ($filter.hasClass('slick-initialized')) {
				$filter.slick('slickNext');
			}
		});

		$filter.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			var $slide = $filter.find('.slick-slide[data-slick-index="' + nextSlide + '"]').first();
			changeFAQCategory(
				$module,
				$slide.data('category'),
				$.trim($slide.find('.m__faqs-category-text').text())
			);
		});

		$module.on('click', '.js__faqs-category', function (e) {
			e.preventDefault();

			$module.find('.js__faqs-category').removeClass('is-active');
			$(this).addClass('is-active');

			if ($(window).innerWidth() > 991) {
				changeFAQCategory(
					$module,
					$(this).data('category'),
					$.trim($(this).find('.m__faqs-category-text').text())
				);
			}
		});

		function changeFAQCategory($module, catId, catName) {
			var showAll = String(catId) === 'all';
			$questions.css('min-height', $questions.outerHeight());

			$questions.fadeOut(function () {
				$module.find('.m__faqs-item-answer').hide();
				$module.find('.m__faqs-item-question').removeClass('is-open');

				$module.find('.m__faqs-item').hide();
				var $visible = showAll
					? $module.find('.m__faqs-item')
					: $module.find('.m__faqs-item[data-category="' + catId + '"]');
				$visible.show();

				$module.find('.m__faqs-item').removeClass('is-last');
				$visible.last().addClass('is-last');

				$module.find('.js__faqs-title').text(catName);
			});

			setTimeout(function () {
				$questions.fadeIn();
				$questions.css('min-height', '');
			}, 500);
		}
	});
}
